import { AxiosResponse } from "axios";
import { parseApiResponse } from "./parseApiResponse";
import { ListDataRequestResponse } from "./types";

export const parseApiListDataResponse = async <T = any, U = any>(
	request: Promise<AxiosResponse<any, any>>
): Promise<ListDataRequestResponse<T, U>> => {
	const responseData = await parseApiResponse(request);

	return {
		data: responseData.data,
		nextPage: responseData.next_page,
		summary: responseData.summary,
	};
};
